<template>
  <div class="column is-one-fifth">
    <h1 class="title is-3">Kunder</h1>
    <nav class="panel">
      <div class="panel-block">
        <p class="control has-icons-left">
          <input
            class="input"
            type="text"
            placeholder="Search"
            v-model="search"
          />
          <span class="icon is-left">
            <i class="fas fa-search" aria-hidden="true"></i>
          </span>
        </p>
      </div>
      <p class="panel-tabs"></p>
      <a
        class="panel-block"
        v-for="customer in getCustomers"
        :class="{ 'is-active': selectedCustomer._id == customer._id }"
        :key="customer.id"
        @click="selectCustomer(customer)"
      >
        {{ customer.first_name }} {{ customer.last_name }}
      </a>
    </nav>
  </div>
</template>

<script>
import router from "@/router.js";
import axios from "@/utils/request.js";

export default {
  name: "CustomerList",
  props: {
    customers: Array,
  },
  data: function () {
    return {
      selectedCustomer: {},
      search: "",
      filteredCustomers: [],
      extendedFields: false,
      options: {
        keys: ["last_name", "first_name"],
      },
    };
  },
  methods: {
    selectCustomer: function (customer) {
      this.selectedCustomer = customer;
      router.push({ path: "customers", query: { id: customer._id } });
      this.$emit("customerSelected", customer);
    },
    getExtendedFields: function () {
      axios.get("/api/settings/extendedfields").then((response) => {
        this.extendedFields = response.data;
      });
    },
  },
  watch: {
    search: function (val) {
      this.$search(val, this.customers, this.options).then((res) => {
        this.filteredCustomers = res;
      });
    },
  },
  computed: {
    getCustomers: function () {
      if (this.filteredCustomers.length == 0) {
        return this.customers;
      } else {
        return this.filteredCustomers;
      }
    },
  },
  created() {

    this.getExtendedFields()
    console.log("hej");

    var id = this.$route.query.id;

    if (id && this.customers.length > 0) {
      var customer = this.customers.filter((customer) => customer._id == id)[0];
      if (customer) {
        this.selectedCustomer = customer;
        this.$emit("customerSelected", customer);
      }
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nbr {
  margin-left: auto;
}

.is-active {
  background-color: hsl(217, 71%, 53%);
  color: white !important;
  border-radius: 10px;
}

.panel {
  border: None;
}

.panel-tabs {
  border: None;
  border-top: None !important;
}

.panel-block {
  border: None;
  color: hsl(0, 0%, 40%);
}

.panel-block:hover {
  color: hsl(0, 0%, 40%) !important;
  border-radius: 10px;
}

.column {
  padding-right: 0.5rem;
  padding-left: 1.25rem;
  box-shadow: inset 0 0 5px 0 #dfdfdf;
  background-color: hsl(0, 0%, 98%);
}

</style>